import React from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import moment from 'moment-jalaali'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import ageCategoryList from '../../constants/ageCategory'

const useStyle = makeStyles((theme) => ({
  contentRoot: {
    padding: theme.spacing(2),
  },
  date: {
    marginBottom: 10,
    textAlign: 'end',
    fontSize: '1rem',
  },
  modalRoot: {
    minWidth: 300,
  },
  title: {
    '& > h6': {
      fontSize: '1rem',
      fontWeight: 700,
    },
  },
  divider: {
    margin: '30px 0px 15px 0px',
  },
}))

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
})

const DialogTitle = withStyles(styles)((props) => {
  const {
    children, classes, onClose, ...other
  } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

export const NotificationModal = (props) => {
  const { setOpen, open = false, data } = props
  const classes = useStyle()

  const handleClose = () => {
    setOpen(null)
  }

  const notification = React.useMemo(() => {
    return data
  }, [data])

  const faDate = React.useMemo(() => (
    moment(notification?.createDate)?.format('jYYYY/jMM/jDD')
  ), [notification])

  return (
    <Dialog classes={{ paper: classes.modalRoot }} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle classes={{ root: classes.title }} id="customized-dialog-title" onClose={handleClose}>
        {notification?.title || 'عنوان'}
      </DialogTitle>
      <MuiDialogContent classes={{ root: classes.contentRoot }} dividers>
        <Typography className={classes.date} variant="h4" component="h4">{faDate}</Typography>
        <Typography>
          {notification?.content}
        </Typography>

        <Divider className={classes.divider} />

        <Typography variant="h5">
          رده‌های سنی
        </Typography>

        <List className={classes.root}>
          {data?.ageCategoryIds.map((age) => (
            <ListItem key={age}>
              <ListItemAvatar>
                <Avatar>
                  {age}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={ageCategoryList?.[(age - 1 !== 6 ? age - 1 : age - 2)]?.title || '--'} />
            </ListItem>
          ))}
        </List>
      </MuiDialogContent>
    </Dialog>
  )
}

NotificationModal.propTypes = {
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  data: PropTypes.object,
}

export default NotificationModal
